/**
 * User Management Service API Client
 *
 * Axios instance configured for User Management Service
 * Uses the unified API client factory for consistent behavior
 */

import { API_CONFIG } from '../config';
import { createApiClient } from './api-client-factory';

/**
 * User Management API Client
 * Handles authentication, user profiles, and role management
 */
const userManagementClient = createApiClient({
  baseURL: API_CONFIG.USER_MANAGEMENT.BASE_URL,
  timeout: API_CONFIG.USER_MANAGEMENT.TIMEOUT,
  withRefreshToken: false, // TODO: Enable when backend supports refresh token
  refreshEndpoint: '/refresh-token',
});

export default userManagementClient;
